import { createContext } from 'react';

import { type PreloadPriority } from '../lazy/types';

export type EventInfo = {
	identifier: string;
	name?: string;
};

type Profiler = {
	onPreload(moduleId: string, priority?: PreloadPriority): void;
	onLoadStart(info: EventInfo): void;
	onLoadComplete(info: EventInfo): void;
	placeholderFallBackMounted(id: string, name?: string, lazyWait?: boolean): void;
	placeholderFallBackUnmounted(id: string, name?: string, lazyWait?: boolean): void;
};

export type ProfilerContextType = {
	current: Profiler | null;
};

export const GlobalReactLooselyLazyProfiler: ProfilerContextType = {
	current: null,
};

export const ProfilerContext = createContext<ProfilerContextType>(GlobalReactLooselyLazyProfiler);
